export const deviceFieldKeysMap = new Map([
    ['macAddress', 'Mac Address'],
    ['macAddressZigbee', 'Mac Address Zigbee'],
    ['lastUpdate', 'Last Update'],
    ['lastReset', 'Last Reset'],
    ['lastSetup', 'Last Setup'],
    ['lastSeen', 'Last Seen'],
    ['lastData', 'Last Data'],
    ['setupDate', 'Setup Date'],
    ['homekitStatus', 'Homekit Status'],
    ['status', 'Status'],
    ['wifiChip', 'Wifi Chip'],
    ['wifiChannel', 'Wifi Channel'],
    ['shield', 'Shield'],
    ['lastStatusStored', 'Last Status Stored'],
    ['hwVersion', 'Hardware version'],
    ['customer', 'Customer'],
    ['command', 'Command'],
    ['customer2', 'Customer 2'],
    ['command2', 'Command 2'],
    ['uptime', 'Uptime'],
    ['room', 'Room'],
    ['fwPrivate', 'Package FW (not displayed)'],
    ['controlledDevices', 'Controlled Devices'],
    ['controlledDevicesLeft', 'Controlled Devices (left button)'],
    ['controlledDevicesMiddle', 'Controlled Devices (middle button)'],
    ['controlledDevicesRight', 'Controlled Devices (right button)'],
    ['battery', 'Battery'],
    ['reachable', 'Reachable'],
    ['configured', 'Configured'],
    ['mfgId', 'MFG id'],
    ['applianceType', 'Appliance Type'],
    ['mode', 'Mode'],
    ['energyType', 'Energy Type'],
    ['packagingId', 'Packaging Id'],
    ['line', 'Line'],
    ['subline', 'Subline'],
    ['lineName', 'Line Name'],
    ['ergonomicId', 'Ergonomic id'],
    ['sdStatus', 'SD Status'],
    ['alimStatus', 'Alim. Status'],
    ['monitoring', 'Monitoring'],
    ['installationVoltage', 'Installation Voltage (mV)'],
    ['installationIlim', 'Installation Ilim'],
    ['stateOfCharge', 'State Of Charge'],
    ['stateOfHealth', 'State Of Health'],
    ['nbCharge', 'Nb. charge'],
    ['batteryTemperatureLevel', 'Battery Temperature Level'],
    ['tamperDetection', 'Tamper Detection'],
    ['tampered', 'Tampered'],
    ['alimentation', 'Alimentation'],
    ['lastActivity', 'Last Activity'],
    ['autoTrigger', 'Auto-trigger'],
    ['notifyRule', 'Notify Rule'],
    ['recordRule', 'Record Rule'],
    ['rfRating', 'RF Rating'],
    ['rfStatus', 'RF Status'],
    ['sirenSoundRule', 'Siren Sound Rule'],
    ['sirenEntryDelay', 'Siren Entry Delay'],
    ['radioId', 'Radio Id'],
    ['motorSpeed', 'Motor Speed'],
    ['voltageDrop', 'Voltage Drop'],
    ['batteryDead', 'Battery Dead'],
    ['groupId', 'Group Id'],
    ['veluxType', 'Velux Type'],
    ['routerId', 'Router Id'],
    ['shareWeatherMap', 'Share Weathermap'],
    ['weatherMapIsFiltered', 'Weathermap Station Filtered'],
    ['weatherMapFilteringReason', 'Filtering Reason'],
    ['stationName', 'Station Name'],
    ['boilerControl', 'Boiler Control'],
    ['dhwControl', 'DHW Control'],
    ['bubendorffMotorType', 'Version'],
    ['thermalControl', 'Thermal Control'],
    ['calibrationMinMax', 'Calibration Min/Max'],
    ['lastCalibration', 'Last Calibration'],
    ['eventualDoubleMac', 'Eventual Double Mac'],
    ['mullerType', 'Muller Type'],
    ['brandName', 'Brand Name'],
    ['heaterNature', 'Heater Nature'],
    ['devicePower', 'Device Power'],
    ['model', 'Model'],
    ['oemSerial', 'OEM Serial'],
    ['iccId', 'ICCID'],
    ['mcuFirmware', 'MCU Firmware'],
    ['deutschTelekomPortalLink', 'Deutsch Telekom Portal Link'],
    ['subtype', 'Subtype'],
    ['button', 'Button'],
    ['totalCount', 'Total number of modules'],
    ['wiredCount', '- Wired modules'],
    ['wirelessCount', '- Wireless modules'],
    ['ticStatus', 'TIC status'],
    ['ticType', 'TIC type'],
    ['refurbished', 'Refurbished'],
    ['migrated', 'Migrated'],
    ['fullFeatureSupported', 'Full feature supported'],
    ['reconstructionStatus', 'Reconstruction Status'],
    ['protocolId', 'Protocol ID'],
    ['protocolHistory', 'Protocol History'],
    ['brandId', 'Brand ID'],
    ['operatingMode', 'Operating Mode'],
    ['keyAttachments', 'Smart Keys'],
    ['manufacturer', 'Manufacturer'],
    ['image', 'Image Type'],
    ['pidAlgoPeriod', 'PID Algo Period'],
    ['lastResetType', 'Last Reset Type'],
    ['feedbackGiven', 'Feedback Given'],
    ['powerSource', 'Power Source'],
]);
